import LocationType from "src/types/LocationType";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type RegionKey = string;

export type RegionExpandState = Record<RegionKey, { expand: boolean }>;

export type LocationExpandState = {
  expand: boolean;
  locationId?: string;
  regions?: RegionExpandState;
};

export type ExpandKey = LocationType | "Pinned";

export type ExpandState = Record<ExpandKey, LocationExpandState>;

export interface SidebarState {
  expand: ExpandState;
}

const createInitialExpandState = (): SidebarState => {
  const expand: ExpandState = {} as ExpandState;

  Object.values(LocationType)
    .filter((value): value is LocationType => typeof value === "number")
    .forEach((key) => {
      expand[key] = { expand: false };
    });

  expand["Pinned"] = { expand: false };

  return {
    expand,
  };
};
interface SidebarExpandStore {
  expand: ExpandState;
  setExpand: (key: ExpandKey, value: boolean) => void;
  setLocationId: (key: ExpandKey, locationId: string) => void;
  setRegionExpand: (key: ExpandKey, region: RegionKey, value: boolean) => void;
  resetExpandState: () => void;
}

export const useSidebarExpandStore = create<SidebarExpandStore>()(
  persist(
    (set) => ({
      ...createInitialExpandState(),
      setExpand: (key, value) =>
        set((store) => ({
          expand: {
            ...store.expand,
            [key]: {
              ...store.expand[key],
              expand: value,
            },
          },
        })),
      setLocationId: (key, locationId) =>
        set((store) => ({
          expand: {
            ...store.expand,
            [key]: {
              ...store.expand[key],
              locationId,
            },
          },
        })),
      setRegionExpand: (key, region, value) =>
        set((store) => {
          const current = store.expand[key];
          const updatedRegions = {
            ...(current.regions ?? {}),
            [region]: { expand: value },
          };

          return {
            expand: {
              ...store.expand,
              [key]: {
                ...current,
                regions: updatedRegions,
              },
            },
          };
        }),

      resetExpandState: () => set(() => ({ ...createInitialExpandState() })),
    }),
    {
      name: "sidebar-expand-store",
    }
  )
);
